import EventHandler from "../../utils/dom/event-handler";
import SelectorEngine from "../../utils/dom/selector-engine";
import Request, { ApiMode } from "../../utils/request";
import Manipulator from '../../utils/dom/manipulator';
import {
	startLoadingAnimation,
	stopLoadingAnimation,
} from "../../utils/dom/loading";

const SELECTOR_WRAPPER = ".p-park-activator-home";
const SELECTOR_CARD = ".p-park-activator-home--card";
const SELECTOR_CARD_BUTTOn = ".p-park-activator-home--card-button";
const CLICK_EVENT = "click";

const IS_LOCAL = false;
class ParkActivatorHome {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this.parkActivatorHomeCard = SelectorEngine.findOne(
			SELECTOR_CARD,
			this._wrapper
		);

		this.parkActivatorHomeCardButton = SelectorEngine.findOne(
			SELECTOR_CARD_BUTTOn,
			this.parkActivatorHomeCard
		);

		this.redirectURL = Manipulator.getDataAttribute(
			this.parkActivatorHomeCardButton,
			"redirectUrl"
		);

		EventHandler.on(this.parkActivatorHomeCardButton, CLICK_EVENT, () => {
			this.loadTraining();
		});
	}

	async loadTraining() {
		startLoadingAnimation();
		try {
			const url = "/api/parksactivators/EnrolledToSafeguarding";
			const response = await Request.post(url, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError,
				},
			});
			const { Success, success, error } = response;
			stopLoadingAnimation();
			if (Success || success) {				
				window.open(`${this.redirectURL}`, '_blank');
				location.reload();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
}

const globalParkActivatorHome = new ParkActivatorHome();
export default globalParkActivatorHome;
